import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchScheduledTasks, addScheduledTask, setTaskActive } from '../../services/api/schedulerService';

export const loadScheduledTasks = createAsyncThunk('scheduler/load', async () => fetchScheduledTasks());

export const createScheduledTaskRecord = createAsyncThunk('scheduler/create', async (payload) => addScheduledTask(payload));

export const toggleScheduledTaskActive = createAsyncThunk(
  'scheduler/toggle',
  async ({ id, active }) => setTaskActive(id, active)
);

const schedulerSlice = createSlice({
  name: 'scheduler',
  initialState: { status: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadScheduledTasks.pending, (state) => { state.status = 'loading'; })
      .addCase(loadScheduledTasks.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(loadScheduledTasks.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(createScheduledTaskRecord.pending, (state) => { state.status = 'loading'; state.error = null; })
      .addCase(createScheduledTaskRecord.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items.unshift(action.payload);
      })
      .addCase(createScheduledTaskRecord.rejected, (state, action) => { state.status = 'failed'; state.error = action.error.message; })
      .addCase(toggleScheduledTaskActive.pending, (state) => { state.error = null; })
      .addCase(toggleScheduledTaskActive.fulfilled, (state, action) => {
        const item = state.items.find((t) => t.id === action.payload.id);
        if (item) item.active = action.payload.active;
      })
      .addCase(toggleScheduledTaskActive.rejected, (state, action) => { state.error = action.error.message; });
  }
});

export default schedulerSlice.reducer;
